(function (upp) {
    'use strict';

    upp
        .controller('upp.HomeContentCtrl', ['$scope', function ($scope) {
        }])
        .controller('upp.HomeCtrl', ['$scope', '$rootScope', '$window', 'appi', 'eShopService', 'config',
            function ($scope, $rootScope, $window, appi, eShopService, config) {
                appi.ui.changeActualOption({text: $rootScope.childuppName, navbarKey: 'home'});
                $scope.infiniteScroll = true;
                $scope.listProducts = eShopService.listEshopProducts;

                config.getLogoPath()
                    .then(function (logo) {
                        $scope.logo = logo;
                    });

                config.getContent().then(function (content) {
                    if (content) {
                        $scope.content = content;
                        $scope.showProducts = false;
                    }
                    else {
                        $scope.showProducts = true;
                    }
                });
            }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/common/controllers/home-content-controller.js